'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 12.51V8.347a.323.323 0 0 0-.321-.322L13.123 8H3.321A.322.322 0 0 0 3 8.322v12.357c0 .177.144.32.321.32h10.124v-3.424h-.643v2.782H3.643v-6.102h3.652v-.642H3.643v-4.97h9.159v1.049h.643V8.644l6.912.023v3.842l-6.912-.007v-1.01h-.643v1.33l-.001.322h.001v.469H9.223v.642h3.579v1.39h.643v-2.502l6.912.009v7.18l-4.962-.01-.001.644 5.284.009a.318.318 0 0 0 .227-.094.319.319 0 0 0 .095-.227V12.51Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }));
});
var FwSet0Livingspace200 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Livingspace200 = FwSet0Livingspace200;